/* GearAndGo – ukazatel dopravy zdarma a soutěže o Prague Car Festival
   v bočním košíku, na stránce košíku a na stránce produktu. */
(function () {
  var FREE = 275000; // doprava zdarma od 2 750 Kč (v haléřích)
  var CONTEST = 50000; // soutěž: nákup nad 500 Kč (bez dopravy)
  var CONTEST_END = new Date('2026-10-25T23:59:00+02:00').getTime();
  var PHONE = '+420 739 295 742';
  /* Soutěž: nákup nad 500 Kč za jakékoli zboží, nepočítá se jen doprava. */
  var lastCart = null;
  var timer = null;

  function kc(cents) {
    return Math.ceil(cents / 100).toLocaleString('cs-CZ').replace(/\s/g, ' ') + ' Kč';
  }

  function html(cart) {
    if (!cart || !cart.item_count) return '';
    var total = cart.total_price || 0;
    var cars = total; /* cena zboží po slevách, bez dopravy */
    var pct = Math.min(100, Math.round((total / FREE) * 100));
    var out = '<div class="gng-cp__row">';
    out += total >= FREE
      ? '<p class="gng-cp__text"><strong>Doprava zdarma je tvoje.</strong></p>'
      : '<p class="gng-cp__text">Do dopravy zdarma chybí <strong>' + kc(FREE - total) + '</strong></p>';
    out += '<div class="gng-cp__bar"><span style="width:' + pct + '%"></span></div></div>';
    if (Date.now() < CONTEST_END) {
      out += '<div class="gng-cp__row gng-cp__contest">';
      if (cars >= CONTEST) {
        out += '<p class="gng-cp__text"><strong>Hraješ o lístky na Prague Car Festival.</strong> Po objednávce pošli číslo objednávky SMS na <a href="sms:' + PHONE.replace(/\s/g, '') + '">' + PHONE + '</a>.</p>';
      } else {
        out += '<p class="gng-cp__text">Nakup ještě za <strong>' + kc(CONTEST - cars) + '</strong> a hraj o lístky na Prague Car Festival (do 25. 10.).</p>';
      }
      out += '</div>';
    }
    return out;
  }

  function ensureBoxes() {
    var head = document.querySelector('cart-drawer .drawer__header');
    if (head && !head.parentNode.querySelector(':scope > .gng-cart-progress')) {
      var d = document.createElement('div');
      d.className = 'gng-cart-progress gng-cart-progress--drawer';
      d.setAttribute('data-gng-cart-progress', '');
      head.insertAdjacentElement('afterend', d);
    }
    var ctas = document.querySelector('#main-cart-footer .cart__ctas');
    if (ctas && !ctas.parentNode.querySelector(':scope > .gng-cart-progress')) {
      var c = document.createElement('div');
      c.className = 'gng-cart-progress gng-cart-progress--page';
      c.setAttribute('data-gng-cart-progress', '');
      ctas.insertAdjacentElement('beforebegin', c);
    }
  }

  function paint() {
    ensureBoxes();
    var h = html(lastCart);
    document.querySelectorAll('[data-gng-cart-progress]').forEach(function (el) {
      if (el.getAttribute('data-gng-html') !== h) {
        el.innerHTML = h;
        el.setAttribute('data-gng-html', h);
      }
      el.hidden = !h;
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { lastCart = cart; paint(); })
        .catch(function () {});
    }, 150);
  }

  function isOwn(node) {
    return node && node.nodeType === 1 && (node.classList.contains('gng-cart-progress') || node.closest('.gng-cart-progress'));
  }

  function init() {
    refresh();
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    document.addEventListener('cart:updated', refresh);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function (list) {
        var foreign = list.some(function (m) {
          if (isOwn(m.target)) return false;
          return Array.prototype.some.call(m.addedNodes, function (n) { return !isOwn(n); }) ||
                 Array.prototype.some.call(m.removedNodes, function (n) { return !isOwn(n); });
        });
        if (foreign) { paint(); refresh(); }
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  var started = false;
  function start() { if (!started) { started = true; init(); } }
  if (document.readyState === 'complete') start();
  else { document.addEventListener('DOMContentLoaded', start); window.addEventListener('load', start); }
})();

/* GearAndGo – jemný efekt kliknutí: krátký kroužek v barvách webu v místě kliknutí */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0 || !e.target.closest) return;
    if (!e.target.closest('a, button, summary, label, [role="button"], .card-wrapper, input[type="submit"]')) return;
    var s = document.createElement('span');
    s.className = 'gng-click';
    s.style.left = e.clientX + 'px';
    s.style.top = e.clientY + 'px';
    document.body.appendChild(s);
    setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 600);
  }, { passive: true });
})();

/* GearAndGo – stránky kolekcí (filtr Smart Filter Search): rychlé volby, české názvy filtrů
   a označení předobjednávek na kartách (seznam z /collections/predobjednavky?view=gng-pre). */
(function () {
  var LABELS = { 'PREORDER': 'Předobjednávka', 'STOCK': 'Skladem' };
  var CHIPS = [
    { label: 'Skladem', type: 'filter', value: 'STOCK' },
    { label: 'Předobjednávky', type: 'filter', value: 'PREORDER' },
    { label: 'Nejnovější', type: 'sort', value: 'created-descending' },
    { label: 'Od nejlevnějšího', type: 'sort', value: 'price-ascending' }
  ];
  var PRE = null;
  var preLoading = false;
  function filterBtn(v) { return document.querySelector('#gf-tree button[data-fvalue="' + v + '"]'); }
  function sortItem(v) { return document.querySelector('.globo-dropdown-custom__options [data-sort="' + v + '"]'); }
  function renameLabels() {
    document.querySelectorAll('#gf-tree .gf-label, .globo-selected-items-wrapper *, .gf-filter-selection *').forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim();
      if (LABELS[t]) el.textContent = LABELS[t];
    });
  }
  function loadPre() {
    if (PRE || preLoading) return;
    try {
      var c = JSON.parse(sessionStorage.getItem('gng-pre') || 'null');
      if (c && Date.now() - c.t < 1800000) { PRE = c.m; return; }
    } catch (e) {}
    preLoading = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var map = {};
    (function page(n) {
      fetch(root + 'collections/predobjednavky?view=gng-pre&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          for (var k in d.items) map[k] = d.items[k];
          if (d.next && n < 20) { page(n + 1); return; }
          PRE = map; preLoading = false;
          try { sessionStorage.setItem('gng-pre', JSON.stringify({ t: Date.now(), m: map })); } catch (e) {}
          schedule();
        })
        .catch(function () { preLoading = false; });
    })(1);
  }
  function markPre() {
    if (!PRE) { loadPre(); if (!PRE) return; }
    document.querySelectorAll('.spf-product-card').forEach(function (card) {
      var a = card.querySelector('.spf-product-card__title a, a.spf-product-card__image-wrapper');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var h = decodeURIComponent(m[1]);
      if (!Object.prototype.hasOwnProperty.call(PRE, h)) return;
      var info = card.querySelector('.spf-product__info');
      if (info && !info.querySelector('.gng-status--pre')) {
        var p = document.createElement('p');
        p.className = 'gng-status gng-status--pre';
        p.textContent = 'Předobjednávka' + (PRE[h] ? ' · dodání ' + PRE[h] : '');
        var price = info.querySelector('.spf-product-card__price-wrapper');
        if (price) price.insertAdjacentElement('afterend', p); else info.appendChild(p);
      }
      var btn = card.querySelector('.spf-product__form-btn-addtocart:not([disabled]) span');
      if (btn && btn.textContent.trim() !== 'Předobjednat') btn.textContent = 'Předobjednat';
    });
  }
  function chipState(bar) {
    bar.querySelectorAll('.gng-chip').forEach(function (b) {
      var on = false;
      if (b.dataset.type === 'filter') { var f = filterBtn(b.dataset.value); on = !!(f && f.getAttribute('aria-checked') === 'true'); }
      else { var sb = document.querySelector('.sort-by-toggle span'); var si = sortItem(b.dataset.value); on = !!(sb && si && sb.textContent.trim() === si.textContent.trim()); }
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function ensureChips() {
    var actions = document.querySelector('.gf-actions');
    if (!actions) return null;
    var bar = document.querySelector('.gng-chips');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'gng-chips';
      bar.setAttribute('role', 'group');
      bar.setAttribute('aria-label', 'Rychlé filtry');
      CHIPS.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'gng-chip'; b.textContent = c.label;
        b.dataset.type = c.type; b.dataset.value = c.value;
        b.addEventListener('click', function () {
          if (c.type === 'filter') { var f = filterBtn(c.value); if (f) f.click(); }
          else { var t = document.querySelector('.sort-by-toggle'); var i = sortItem(c.value); if (i) { if (t) t.click(); i.click(); } }
          setTimeout(tick, 600);
        });
        bar.appendChild(b);
      });
    }
    if (bar.nextElementSibling !== actions) actions.parentNode.insertBefore(bar, actions);
    return bar;
  }
  function tick() {
    if (document.querySelector('.spf-product-card')) markPre();
    if (!document.querySelector('#gf-tree')) return;
    renameLabels();
    var bar = ensureChips();
    if (bar) chipState(bar);
  }
  var pending = null;
  function schedule() { if (!pending) pending = setTimeout(function () { pending = null; tick(); }, 250); }
  function init() {
    tick();
    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (t.nodeType === 1 && t.closest && t.closest('.gng-chips')) continue;
          schedule(); return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
